export const MODAL_CLOSE_TIMEOUT = 300;
